import OptionalTextAreaInput from "components/ValidatedFields/OptionalTextAreaInput";
import React from "react";
import { Button } from "semantic-ui-react";

interface Props {
  item: server.dto.DocumentChecklistItem
  onDeclined: (reason: string) => void
}

const ChecklistNotAnsweredDeclineReasonRowCard = (props: Props) => {
  const [declinedReason, setDeclinedReason] = React.useState("");
  const [savingDecline, setSavingReject] = React.useState(false);

  const onDecline = () => {
    if (savingDecline) return;
    setSavingReject(true);
    props.onDeclined(declinedReason);
  };

  const { item } = props;
  return <div className="flex-column">
    <div className="grow1">
      <div>
        <h3>{item.question}</h3>
      </div>
    </div>

    <div>
      <OptionalTextAreaInput
        value={declinedReason}
        placeholder={RESX.Checklist.ProvideAReasonWhyYouDecline}
        onChange={value => { setDeclinedReason(value as string); }}
        rows={7}
        maxLength={serverReference.constants.checklist.maxDeclinedReasonLength}
      />
      <div className="margin-top flex justify-end">
        <Button
          loading={savingDecline}
          color="red"
          onClick={onDecline}
        >
          {RESX.Buttons.Decline}
        </Button>
      </div>
    </div>
  </div>;
};

export default ChecklistNotAnsweredDeclineReasonRowCard;